// Generated by scripts/fetch-images.mjs — do not edit by hand.
export interface PhotoCredit {
  src: string;
  place: string;
  title: string;
  author: string;
  license: string;
  licenseUrl: string;
  source: string;
}

export const photoCredits: PhotoCredit[] = [
  {
    "src": "/images/hero-pulag-sunrise.webp",
    "place": "Mt. Pulag, Benguet",
    "title": "Mount Pulag Summit",
    "author": "FranzSeph",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "source": "https://commons.wikimedia.org/wiki/File:Mount_Pulag_Summit.jpg"
  },
  {
    "src": "/images/pulag-sea-of-clouds.webp",
    "place": "Mt. Pulag, Benguet",
    "title": "Mount Pulag, Kabayan, Philippines (Unsplash)",
    "author": "Joanne Caselyn Suarez joannecaselynsuarez",
    "license": "CC0",
    "licenseUrl": "http://creativecommons.org/publicdomain/zero/1.0/deed.en",
    "source": "https://commons.wikimedia.org/wiki/File:Mount_Pulag,_Kabayan,_Philippines_(Unsplash).jpg"
  },
  {
    "src": "/images/apo.webp",
    "place": "Mt. Apo, Mindanao",
    "title": "The Ring of Mt. Apo",
    "author": "Bro. Jeffrey Pioquinto, SJ",
    "license": "CC BY 2.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/2.0",
    "source": "https://commons.wikimedia.org/wiki/File:The_Ring_of_Mt._Apo.jpg"
  },
  {
    "src": "/images/batulao.webp",
    "place": "Mt. Batulao, Batangas",
    "title": "Dinosaur Back Mountain of Batulao",
    "author": "Billy Palatino",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "source": "https://commons.wikimedia.org/wiki/File:Dinosaur_Back_Mountain_of_Batulao.jpg"
  },
  {
    "src": "/images/page-bmc.webp",
    "place": "Mt. Pulag, Benguet",
    "title": "Verdant Mt. Pulag grasslands",
    "author": "Hcmnavarramd",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "source": "https://commons.wikimedia.org/wiki/File:Verdant_Mt._Pulag_grasslands.jpg"
  },
  {
    "src": "/images/page-open-climbs.webp",
    "place": "Mt. Pulag, Benguet",
    "title": "Mount Pulag Hikers",
    "author": "Jeremias Telva",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "source": "https://commons.wikimedia.org/wiki/File:Mount_Pulag_Hikers.jpg"
  },
  {
    "src": "/images/page-outreach.webp",
    "place": "Kibungan, Benguet",
    "title": "Kibuñgan Cross country (KXC) -5",
    "author": "Aninah Ong",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "source": "https://commons.wikimedia.org/wiki/File:Kibu%C3%B1gan_Cross_country_(KXC)_-5.jpg"
  },
  {
    "src": "/images/page-sart.webp",
    "place": "Mt. Pulag, Benguet",
    "title": "Majestic Pulag",
    "author": "Emman Foronda",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "source": "https://commons.wikimedia.org/wiki/File:Majestic_Pulag.jpg"
  },
  {
    "src": "/images/page-announcements.webp",
    "place": "Mt. Ulap, Benguet",
    "title": "Mt. Ulap 3",
    "author": "Jpcabarles",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "source": "https://commons.wikimedia.org/wiki/File:Mt._Ulap_3.jpg"
  },
  {
    "src": "/images/page-surveys.webp",
    "place": "Mt. Batulao, Batangas",
    "title": "Mt.Batulao",
    "author": "Billy Palatino",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "source": "https://commons.wikimedia.org/wiki/File:Mt.Batulao.jpg"
  },
  {
    "src": "/images/gallery-pulag-sunrise.webp",
    "place": "Mt. Pulag, Benguet",
    "title": "Hikers watching sunrise at Mount Pulag summit",
    "author": "CarolynCapillo",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "source": "https://commons.wikimedia.org/wiki/File:Hikers_watching_sunrise_at_Mount_Pulag_summit.jpg"
  },
  {
    "src": "/images/gallery-lake-venado.webp",
    "place": "Lake Venado, Mt. Apo",
    "title": "Lake Venado",
    "author": "JBYBIOSA",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "source": "https://commons.wikimedia.org/wiki/File:Lake_Venado.jpg"
  },
  {
    "src": "/images/gallery-batulao-ridge.webp",
    "place": "Mt. Batulao, Batangas",
    "title": "Batulao - Allan Jay Quesada",
    "author": "Allan Jay Quesada",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "source": "https://commons.wikimedia.org/wiki/File:Batulao_-_Allan_Jay_Quesada.jpg"
  },
  {
    "src": "/images/gallery-kibungan.webp",
    "place": "Kibungan, Benguet",
    "title": "Kibuñgan Cross country (KXC) -1",
    "author": "Aninah Ong",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "source": "https://commons.wikimedia.org/wiki/File:Kibu%C3%B1gan_Cross_country_(KXC)_-1.jpg"
  },
  {
    "src": "/images/gallery-marami.webp",
    "place": "Mt. Marami, Cavite",
    "title": "Mt. Marami",
    "author": "Dionisia.besas",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "source": "https://commons.wikimedia.org/wiki/File:Mt._Marami.jpg"
  },
  {
    "src": "/images/gallery-tarak.webp",
    "place": "Tarak Ridge, Bataan",
    "title": "Tarak Ridge campsite, Mount Mariveles",
    "author": "Zeus Angelo Salvo",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "source": "https://commons.wikimedia.org/wiki/File:Tarak_Ridge_campsite,_Mount_Mariveles.jpg"
  },
  {
    "src": "/images/section-about.webp",
    "place": "Mt. Guiting-Guiting, Romblon",
    "title": "Guiting-guiting 1",
    "author": "Androkoy",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "source": "https://commons.wikimedia.org/wiki/File:Guiting-guiting_1.jpg"
  },
  {
    "src": "/images/section-explore.webp",
    "place": "Mt. Pinatubo crater lake",
    "title": "Mt.Pinatubo-The Crater Paradise",
    "author": "Emman Asuncion Foronda",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "source": "https://commons.wikimedia.org/wiki/File:Mt.Pinatubo-The_Crater_Paradise.jpg"
  },
  {
    "src": "/images/section-activities.webp",
    "place": "Mt. Guiting-Guiting, Romblon",
    "title": "Mount Guiting Guiting 4",
    "author": "Ray Santa Maria",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "source": "https://commons.wikimedia.org/wiki/File:Mount_Guiting_Guiting_4.jpg"
  },
  {
    "src": "/images/section-training.webp",
    "place": "Mt. Kitanglad, Bukidnon",
    "title": "Mount Kitanglad",
    "author": "Ray Santa Maria",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "source": "https://commons.wikimedia.org/wiki/File:Mount_Kitanglad.jpg"
  },
  {
    "src": "/images/section-community.webp",
    "place": "Mt. Kanlaon, Negros Island",
    "title": "Mount Canlaon",
    "author": "Studphil",
    "license": "Public domain",
    "licenseUrl": "",
    "source": "https://commons.wikimedia.org/wiki/File:Mount_Canlaon.JPG"
  },
  {
    "src": "/images/section-media.webp",
    "place": "Mt. Apo, Mindanao",
    "title": "Philippines Highest Summit",
    "author": "Margareth16",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "source": "https://commons.wikimedia.org/wiki/File:Philippines_Highest_Summit.jpg"
  },
  {
    "src": "/images/gallery-pinatubo-crater.webp",
    "place": "Mt. Pinatubo crater lake",
    "title": "Crater of Mt.Pinatubo",
    "author": "Ambience28",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "source": "https://commons.wikimedia.org/wiki/File:Crater_of_Mt.Pinatubo.jpg"
  },
  {
    "src": "/images/gallery-arayat.webp",
    "place": "Mt. Arayat, Pampanga",
    "title": "Mount Arayat nature gem",
    "author": "Mr ShmilyDigital",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "source": "https://commons.wikimedia.org/wiki/File:Mount_Arayat_nature_gem.jpg"
  },
  {
    "src": "/images/gallery-halcon.webp",
    "place": "Mt. Halcon, Oriental Mindoro",
    "title": "Morning View of Halcon",
    "author": "Orlan Rovira Frane",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "source": "https://commons.wikimedia.org/wiki/File:Morning_View_of_Halcon.jpg"
  }
];
